import React from 'react';

import {
  fields,
  validationUtil
} from 'iron-forge-react-modules';

import { FormModal } from 'modules';
import { useForm } from 'react-hook-form';
import Big from 'big.js';
import * as types from './types';




const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  value: Big;

  onChange: (value: Big) => void;
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const form = useForm<types.IFormState>({
    defaultValues: {
      priceDollars: props.value.toFixed(2)
    }
  });

  const processSubmit = React.useCallback(
    async (formState: types.IFormState) => {
      props.onChange(new Big(formState.priceDollars));
      props.onClose();
    },
    [props]
  );

  return (
    <FormModal.FC
      title="Edit Price"
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}>
      <ControlledTextField
        fieldKey="priceDollars"
        formControl={form.control}
        extraValidationRules={{
          pattern: validationUtil.reDecimalNumber
        }} />
    </FormModal.FC>
  );
};
